import styled from 'styled-components';

export const Content = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',

  padding: '5rem',
  borderRadius: '10rem',

  '& img': {
    height: theme.legacyDimensions.colorCardHeight,
    width: '100%',
    objectFit: 'cover',
  },
}));

export const ColorPriceSection = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',

  height: '45rem',
  width: '100%',

  fontSize: theme.typography.size16,
  color: theme.palette.darkLiver,
}));

export const ColorInfo = styled.div(({ theme }) => ({
  display: 'block',
  margin: '10rem',

  fontFamily: theme.typography.family.arial,
}));

export const ColorName = styled.div(({ theme }) => ({
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  backgroundColor: theme.defaultTheme.eeWhite,

  fontSize: theme.typography.size16,
  fontWeight: 'bold',
}));

export const PriceContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  width: '100%',
});

export const DiscountContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
});

export const SampleLink = styled.a(({ theme }) => ({
  textDecoration: 'none',
  color: theme.palette.tuftsBlue,
  fontSize: theme.typography.size12,
  marginLeft: 'auto', // This positions the link to the right even if there's no discount
}));
